const BannerImage = () => {
  return (
    <svg
      width="1377"
      height="837"
      viewBox="0 0 1377 837"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="banner-image"
    >
      <path
        d="M54.5771 600.552C53.9737 612.459 45.245 639.322 15.1569 651.518C-110.143 771.385 576.694 784.239 779.225 766.453C981.756 748.667 1141.65 844.322 1315.02 836.55C1488.39 828.778 1258.3 707.715 1110.68 641.355C963.052 574.994 1251.46 388.618 1088.35 424.488C925.241 460.358 918.403 415.52 1141.65 268.751C1364.9 121.981 798.131 -63.0509 804.969 21.0951C811.807 105.241 490.814 233.03 425.449 181.914C360.084 130.799 401.515 161.588 248.661 212.554C95.8074 263.52 197.174 178.178 116.322 181.914C35.4704 185.651 54.5771 247.079 150.714 294.308C246.851 341.538 150.714 415.521 116.322 415.521C81.9299 415.521 85.5501 480.536 140.457 463.946C184.382 450.674 196.57 469.476 197.174 480.536C196.034 491.596 178.268 515.509 116.322 522.683C54.376 529.857 49.3479 577.585 54.5771 600.552Z"
        fill="#006FD6"
        fillOpacity="0.11"
      />
      <path
        d="M800 320.058L1155 144.058C1035.38 179.714 1015.81 141.784 997.757 106.061L997.596 105.741C984.319 79.4626 971.707 54.5015 920.5 61.0605C832.588 72.3211 894.333 268.392 800 320.058Z"
        fill="#A8D8FF"
        fillOpacity="0.42"
      />
      <path
        d="M363.029 190.024C364.078 190.932 429 265.996 429 382L326.33 284.995L204 226.321C256.573 213.844 361.981 189.117 363.029 190.024Z"
        fill="#A8D8FF"
        fillOpacity="0.47"
      />
      <path
        d="M909 718C832.2 679.2 533 734.167 393 766.5C527.333 766.5 800.6 765.5 819 761.5C837.4 757.5 954 776.167 1010 786C1008.33 779.5 985.8 756.8 909 718Z"
        fill="#BBD8F1"
      />
      <g clipPath="url(#clip0)">
        <path
          d="M607.679 672.802C852.164 672.802 1050.36 668.198 1050.36 662.519C1050.36 656.841 852.164 652.237 607.679 652.237C363.194 652.237 165 656.841 165 662.519C165 668.198 363.194 672.802 607.679 672.802Z"
          fill="#E6E6E6"
        />
        <path
          d="M998.78 322.224H781.675V321.088C781.675 320.649 781.589 320.215 781.421 319.81C781.253 319.405 781.007 319.037 780.697 318.727C780.387 318.417 780.019 318.172 779.614 318.004C779.209 317.836 778.775 317.75 778.337 317.75H686.569C686.131 317.75 685.696 317.836 685.292 318.004C684.887 318.172 684.519 318.417 684.209 318.727C683.899 319.037 683.653 319.405 683.485 319.81C683.317 320.215 683.231 320.649 683.231 321.088V322.224H465.231C463.302 322.224 461.393 322.604 459.611 323.342C457.829 324.08 456.21 325.162 454.847 326.526C453.483 327.889 452.401 329.508 451.663 331.29C450.925 333.072 450.545 334.981 450.545 336.91V634.194C450.545 636.122 450.925 638.032 451.663 639.814C452.401 641.595 453.483 643.214 454.847 644.578C456.21 645.942 457.829 647.023 459.611 647.761C461.393 648.499 463.302 648.879 465.231 648.879H998.78C1002.67 648.879 1006.41 647.332 1009.16 644.578C1011.92 641.824 1013.47 638.089 1013.47 634.194V336.91C1013.47 333.015 1011.92 329.28 1009.16 326.526C1006.41 323.772 1002.67 322.224 998.78 322.224Z"
          fill="#3F3D56"
        />
        <path
          d="M476.91 347.401C476.461 347.406 476.033 347.589 475.718 347.909C475.404 348.23 475.23 348.662 475.234 349.111V636.8C475.23 637.248 475.404 637.68 475.718 638.001C476.033 638.321 476.461 638.504 476.91 638.509H987.101C987.549 638.504 987.978 638.321 988.292 638.001C988.606 637.68 988.78 637.248 988.776 636.8V349.111C988.78 348.662 988.606 348.23 988.292 347.909C987.978 347.589 987.549 347.406 987.101 347.401H476.91Z"
          fill="white"
        />
        <path
          d="M731.558 340.123C734.524 340.123 736.928 337.719 736.928 334.754C736.928 331.788 734.524 329.384 731.558 329.384C728.592 329.384 726.188 331.788 726.188 334.754C726.188 337.719 728.592 340.123 731.558 340.123Z"
          fill="#6C63FF"
        />
        <path
          d="M1023.24 628.843H972.149V623.567C972.149 623.277 971.822 623.042 971.419 623.042H953.901C953.498 623.042 953.171 623.277 953.171 623.567V628.843H942.222V623.567C942.222 623.277 941.896 623.042 941.492 623.042H923.974C923.571 623.042 923.244 623.277 923.244 623.567V628.843H912.296V623.567C912.296 623.277 911.969 623.042 911.566 623.042H894.048C893.644 623.042 893.318 623.277 893.318 623.567V628.843H882.369V623.567C882.369 623.277 882.042 623.042 881.639 623.042H864.121C863.718 623.042 863.391 623.277 863.391 623.567V628.843H852.442V623.567C852.442 623.277 852.115 623.042 851.712 623.042H834.194C833.791 623.042 833.464 623.277 833.464 623.567V628.843H822.516V623.567C822.516 623.277 822.189 623.042 821.786 623.042H804.268C803.864 623.042 803.538 623.277 803.538 623.567V628.843H792.589V623.567C792.589 623.277 792.262 623.042 791.859 623.042H654.634C654.231 623.042 653.904 623.277 653.904 623.567V628.843H642.955V623.567C642.955 623.277 642.629 623.042 642.225 623.042H624.707C624.304 623.042 623.977 623.277 623.977 623.567V628.843H613.029V623.567C613.029 623.277 612.702 623.042 612.299 623.042H594.781C594.377 623.042 594.051 623.277 594.051 623.567V628.843H583.102V623.567C583.102 623.277 582.775 623.042 582.372 623.042H564.854C564.451 623.042 564.124 623.277 564.124 623.567V628.843H553.175V623.567C553.175 623.277 552.848 623.042 552.445 623.042H534.927C534.524 623.042 534.197 623.277 534.197 623.567V628.843H523.249V623.567C523.249 623.277 522.922 623.042 522.519 623.042H505C504.597 623.042 504.271 623.277 504.271 623.567V628.843H493.322V623.567C493.322 623.277 492.995 623.042 492.592 623.042H475.074C474.671 623.042 474.344 623.277 474.344 623.567V628.843H440.768C431.093 628.843 423.25 634.481 423.25 641.436V647.131C423.25 654.086 431.093 659.724 440.768 659.724H1023.24C1032.92 659.724 1040.76 654.086 1040.76 647.131V641.436C1040.76 634.481 1032.92 628.843 1023.24 628.843Z"
          fill="#3F3D56"
        />
        <path
          d="M928.492 403.837H742.069C740.101 403.837 738.506 405.432 738.506 407.399V586.698C738.506 588.665 740.101 590.26 742.069 590.26H928.492C930.459 590.26 932.054 588.665 932.054 586.698V407.399C932.054 405.432 930.459 403.837 928.492 403.837Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M336.114 235.588C336.525 243.953 336.059 252.337 334.724 260.605C334.724 260.605 324.995 282.843 336.114 292.572C347.233 302.301 368.081 263.385 368.081 263.385C366.639 254.75 365.807 246.634 368.081 241.147L336.114 235.588Z"
          fill="#FFB8B8"
        />
        <path
          d="M351.403 507.999V538.575C351.403 538.575 347.233 595.559 351.403 609.458L350.013 635.865H365.301L369.471 603.898C369.471 603.898 381.979 563.593 377.81 538.575L380.589 507.999H351.403Z"
          fill="#FFB8B8"
        />
        <path
          d="M329.165 507.999V538.575C329.165 538.575 333.335 595.559 329.165 609.458L330.555 635.865H315.267L311.097 603.898C311.097 603.898 298.588 563.593 302.758 538.575L299.978 507.999H329.165Z"
          fill="#FFB8B8"
        />
        <path
          d="M293.724 393.336C293.724 393.336 285.385 446.15 290.944 476.727C296.504 507.304 296.504 517.033 296.504 517.033L331.25 515.643L340.979 458.659L349.318 517.033L391.013 510.083C391.013 510.083 391.013 465.608 392.403 455.879C393.793 446.15 393.793 390.556 393.793 390.556L293.724 393.336Z"
          fill="#2F2E41"
        />
        <path
          d="M368.081 635.865C368.081 635.865 352.792 626.136 345.843 635.865V652.543C345.843 652.543 340.284 665.052 359.742 662.272C379.2 659.492 372.25 649.763 372.25 649.763L368.081 635.865Z"
          fill="#2F2E41"
        />
        <path
          d="M312.487 635.865C312.487 635.865 327.775 626.136 334.724 635.865V652.543C334.724 652.543 340.284 665.052 320.826 662.272C301.368 659.492 308.317 649.763 308.317 649.763L312.487 635.865Z"
          fill="#2F2E41"
        />
        <path
          d="M354.182 249.486C366.464 249.486 376.42 239.53 376.42 227.249C376.42 214.967 366.464 205.011 354.182 205.011C341.901 205.011 331.945 214.967 331.945 227.249C331.945 239.53 341.901 249.486 354.182 249.486Z"
          fill="#FFB8B8"
        />
        <path
          d="M344.453 280.063L334.893 257.569L324.995 261.995L312.487 334.267L313.877 403.76C313.877 403.76 377.81 400.98 386.149 405.149C394.488 409.319 376.42 268.944 376.42 268.944L368.081 258.542L344.453 280.063Z"
          fill="#6C63FF"
        />
        <path
          d="M336.402 249.486C336.402 249.486 315.267 255.046 315.267 263.385C315.267 263.385 294.419 267.554 294.419 271.724C294.419 275.893 293.029 381.522 293.029 381.522C293.029 381.522 280.52 405.15 290.249 424.607L288.859 435.726L316.656 438.506L336.114 267.554L336.402 249.486Z"
          fill="#2F2E41"
        />
        <path
          d="M366.403 249.486C366.403 249.486 387.539 255.046 387.539 263.385C387.539 263.385 408.387 267.554 408.387 271.724C408.387 275.893 409.776 381.522 409.776 381.522C409.776 381.522 422.285 405.15 412.556 424.607L413.946 435.726L386.149 438.506L366.691 267.554L366.403 249.486Z"
          fill="#2F2E41"
        />
        <path
          d="M372.25 198.062C372.25 198.062 373.64 192.502 366.691 195.282C366.691 195.282 358.352 185.553 350.013 192.503C350.013 192.503 333.335 189.723 333.335 203.621C333.335 217.52 332.548 222.109 332.548 222.109C332.548 222.109 337.504 209.181 347.233 210.571C353.179 211.42 356.529 210.712 358.235 210.033C360.08 209.244 362.148 209.146 364.059 209.757C365.259 210.163 366.361 210.816 367.293 211.675C368.225 212.533 368.967 213.577 369.471 214.74C370.327 216.714 371.334 218.619 372.483 220.438C374.104 222.861 375.418 225.476 376.396 228.222V228.222L379.2 211.96C379.2 211.96 380.589 203.621 376.42 200.842C376.42 200.842 377.81 196.672 372.25 198.062Z"
          fill="#2F2E41"
        />
        <path
          className="rect-path"
          d="M794.54 434.931H420.251V556.867H794.54V434.931Z"
          fill="#006FD6"
        />
        <path
          d="M268.706 416.963C268.706 416.963 260.367 448.93 272.876 446.15C285.385 443.37 282.605 415.573 282.605 415.573L268.706 416.963Z"
          fill="#FFB8B8"
        />
        <path
          d="M434.099 416.963C434.099 416.963 442.438 448.93 429.929 446.15C417.42 443.37 420.2 415.573 420.2 415.573L434.099 416.963Z"
          fill="#FFB8B8"
        />
        <path
          d="M301.368 271.724L297.532 268.738C297.532 268.738 293.029 268.944 291.639 271.724C290.249 274.504 268.012 343.996 268.012 343.996C268.012 343.996 261.062 380.132 265.232 402.37L266.622 419.048H286.08L284.69 392.641L298.588 339.827L301.368 271.724Z"
          fill="#2F2E41"
        />
        <path
          d="M401.437 271.724L405.273 268.738C405.273 268.738 409.776 268.944 411.166 271.724C412.556 274.504 434.794 343.996 434.794 343.996C434.794 343.996 441.743 380.132 437.573 402.37L436.183 419.048H416.725L418.115 392.641L404.217 339.827L401.437 271.724Z"
          fill="#2F2E41"
        />
        <path
          className="white-path"
          d="M514.088 450.306H492.882V471.512H514.088V450.306Z"
          fill="white"
        />
        <path d="M721.909 459.849H551.199V461.969H721.909V459.849Z" fill="white" />
        <path
          className="orange-path"
          d="M514.088 485.296H492.882V506.502H514.088V485.296Z"
          fill="#FFA800"
        />
        <path d="M721.909 494.839H551.199V496.959H721.909V494.839Z" fill="white" />
        <path
          className="green-path"
          d="M514.088 520.286H492.882V541.492H514.088V520.286Z"
          fill="#1BC5BD"
        />
        <path d="M721.909 529.829H551.199V531.949H721.909V529.829Z" fill="white" />
        <g filter="url(#filter0_d)">
          <rect x="834" y="431" width="116" height="34" rx="7" fill="white" />
        </g>
        <rect x="870" y="438" width="65" height="4" fill="#F0FDA4" />
        <rect x="860" y="446" width="65" height="4" fill="#FFA800" />
        <rect x="843" y="454" width="65" height="4" fill="#FD5C63" />
        <g filter="url(#filter1_d)">
          <rect x="863" y="479" width="116" height="34" rx="7" fill="white" />
        </g>
        <rect x="899" y="486" width="65" height="4" fill="#F0FDA4" />
        <rect x="889" y="494" width="65" height="4" fill="#FFA800" />
        <rect x="872" y="502" width="65" height="4" fill="#FD5C63" />
        <g filter="url(#filter2_d)">
          <rect x="834" y="527" width="116" height="34" rx="7" fill="white" />
        </g>
        <rect x="870" y="534" width="65" height="4" fill="#F0FDA4" />
        <rect x="860" y="542" width="65" height="4" fill="#FFA800" />
        <rect x="843" y="550" width="65" height="4" fill="#FD5C63" />
        <path
          d="M826 606C835.389 606 843 598.389 843 589C843 579.611 835.389 572 826 572C816.611 572 809 579.611 809 589C809 598.389 816.611 606 826 606Z"
          fill="#6C63FF"
        />
        <path d="M836 589H827V580H825V589H816V591H825V600H827V591H836V589Z" fill="white" />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="827"
          y="425"
          width="134"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology radius="5" operator="dilate" in="SourceAlpha" result="effect1_dropShadow" />
          <feOffset dx="2" dy="3" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.916667 0 0 0 0 0.916667 0 0 0 0 0.916667 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="filter1_d"
          x="856"
          y="473"
          width="134"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology radius="5" operator="dilate" in="SourceAlpha" result="effect1_dropShadow" />
          <feOffset dx="2" dy="3" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.916667 0 0 0 0 0.916667 0 0 0 0 0.916667 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="filter2_d"
          x="827"
          y="521"
          width="134"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology radius="5" operator="dilate" in="SourceAlpha" result="effect1_dropShadow" />
          <feOffset dx="2" dy="3" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.916667 0 0 0 0 0.916667 0 0 0 0 0.916667 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="835.28"
          y1="403.837"
          x2="835.28"
          y2="590.26"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.228184" stopColor="#40A9FF" />
          <stop offset="0.672418" stopColor="#40A9FF" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="885.358" height="482.802" fill="white" transform="translate(165 190)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BannerImage;
